import { FlowStepActionFunction } from '../flow-engine';
import { APIContextActions } from '../../api/APIContext';

export const action: FlowStepActionFunction = function (_apiActions: APIContextActions): void {
  //
};
